import * as tslib_1 from "tslib";
import confirmItemActionAllowed from '../utils/confirmItemActionAllowed';
import getLatestNonDraftItemIdFromConversation from '../utils/getLatestNonDraftItemIdFromConversation';
import { lazyForwardMessage } from 'owa-mail-compose-store';
import * as mailModuleOrchestrator from 'owa-mail-module-orchestrator';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import { action } from 'satcheljs/lib/legacy';
export default action('forwardConversation')(function forwardConversation(conversationId, actionSource, instrumentationContexts) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var referenceItemId, restrictionToConfirm;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getLatestNonDraftItemIdFromConversation(conversationId)];
                case 1:
                    referenceItemId = _a.sent();
                    if (referenceItemId && referenceItemId.Id) {
                        restrictionToConfirm = { ForwardAllowed: true };
                        if (confirmItemActionAllowed(referenceItemId.Id, restrictionToConfirm, format(strings.irm_actionNotAllowedOnThisConversation, strings.itemHeaderForward))) {
                            lazyForwardMessage.importAndExecute(referenceItemId, actionSource, instrumentationContexts);
                            mailModuleOrchestrator.lazyOnReplyOrReplyAllOrForwardMessage.importAndExecute();
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=forwardConversation.js.map